import React, {Component} from 'react'
import OrderHistoriesTable from './OrderHistoriesTable'

class OrderHistoriesContainer extends Component {
    render() {
        return (
            <div className='OrderHistoriesContainer'>
                <OrderHistoriesTable {...this.props}/>
            </div>
        )
    }
}

export default OrderHistoriesContainer
